/*

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Browser-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Browser-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Chrome-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Chrome-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-system-browser-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-system-browser-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-external-browser-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Browser-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Browser-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Chrome-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Chrome-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-system-browser-Bottom.png
https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-system-browser-Top.png

https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-external-browser-Top.png

*/

const imageMapping = {
    ios: {
      google: {
        facebook: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-system-browser-Top.png',
        instagram: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-external-browser-Top.png',
        linkedin: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Browser-Top.png',
        twitter: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Chrome-Bottom.png',
        default: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-system-browser-Top.png',
      },
  
      outlook: {
        facebook: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-system-browser-Top.png',
        instagram: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-external-browser-Top.png',
        linkedin: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Browser-Bottom.png',
        default: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-system-browser-Top.png',
      },
    },
  
    android: {
  
      google: {
        linkedin: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Browser-Top.png',
        facebook: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-system-browser-Top.png',
        instagram: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Chrome-Top.png',
        default: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Google-Open-in-Browser-Top.png',
      },
  
      outlook: {
        default: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/Outlook-Open-in-Browser-Top.png',
      },
    },
  };
  
  export default imageMapping;
  
  export function getImageGuideFor (os, calendar, options = {}) {
    let imageMap = imageMapping[os];
    if (!imageMap) {
      imageMap = imageMapping.ios;
    }
  
    if (calendar === 'google') {
      imageMap = imageMap.google;
    } else {
      imageMap = imageMap.outlook;
    }
  
    let image = imageMap.default;
  
    if (options.app) {
      image = imageMap[options.app];
      if (!image) {
        image = imageMap.default;
      }
    }
    return image;
  }